module.exports = __webpack_public_path__ + "assets/e8ed66a42b9d66020ef829644b032af5.png";